module.exports = __webpack_public_path__ + "ab3.no1.0961d4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ab3.no1.jpg
// module id = +up6
// module chunks = 0